import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectReportById } from './reportsSlice';
import { SELL_CREDIT } from '../../constant/variables';

const ReportRow = ({ id }) => {
  const report = useSelector((state) => selectReportById(state, id));
  if (!report) {
    return null; // or some loading state
  }
  return (
    <tr key={report.uid}>
      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
        {new Date(
          (report.createdAt.seconds +
            report.createdAt.nanoseconds * 0.00000001) *
            1000
        ).toLocaleString()}
      </td>
      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
        {parseFloat(report.walletBalanceBefore).toFixed(2)}
      </td>
      <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell">
        {parseFloat(report.walletBalanceAfter).toFixed(2)}
      </td>
      <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
        {parseFloat(report.amount).toFixed(2)}
      </td>
      <td className="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 lg:table-cell">
        {report.eventType === SELL_CREDIT ? 'Sold' : 'Purchased'}
      </td>
    </tr>
  );
};
ReportRow.propTypes = {
  id: PropTypes.string.isRequired,
};
ReportRow.defaultProps = {
  id: null,
};
export default ReportRow;
